module.exports = __webpack_public_path__ + "static/best_req_smallbiz-929d8e268cbff0eab904919b7dadee08.svg";